import React from 'react';

import useHomeContext from 'Context/HomeContext';
import NoHomeResource from './NoHomeResource';
import HasHomeResource from './HasHomeResource';

const HomeContent = () => {
  const { homeResource } = useHomeContext();
  if (homeResource) {
    return <HasHomeResource />;
  }
  return <NoHomeResource />;
};

export default HomeContent;
